
export default function MasterclassHeader() {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-24 overflow-hidden">
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/e08e53b07a0e4e08223a239cb695c107.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="max-w-4xl">
          <div className="inline-block bg-yellow-500 text-black px-6 py-2 rounded-full font-bold mb-6">
            <i className="ri-star-fill mr-2"></i>
            Exklusives Insider-Seminar
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Dubai Masterclass:<br />
            <span className="text-yellow-500">Vergangenheit – Gegenwart – Zukunft</span>
          </h1>
          
          <p className="text-2xl text-gray-300 mb-8 leading-relaxed">
            Investment, Immobilien, Freezones, GCC &amp; globale Chancen
          </p>
          
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 mb-8">
            <p className="text-lg text-gray-200 leading-relaxed">
              Dieses hochkarätige Seminar bietet einen umfassenden <strong className="text-yellow-500">360°-Blick</strong> auf Dubai und die Vereinigten Arabischen Emirate – von den historischen Anfängen über die heutige Weltmetropole bis hin zu den massiven wirtschaftlichen Chancen der nächsten 10–20 Jahre.
            </p>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-6 mb-12">
            <div className="flex items-center text-white text-lg">
              <i className="ri-calendar-line w-6 h-6 flex items-center justify-center mr-3"></i>
              <span>05.02.2026 • Tag 2</span>
            </div>
            <div className="w-1 h-6 bg-white/50"></div>
            <div className="flex items-center text-white text-lg">
              <i className="ri-time-line w-6 h-6 flex items-center justify-center mr-3"></i>
              <span>09:00 - 16:00 Uhr</span>
            </div>
            <div className="w-1 h-6 bg-white/50"></div>
            <div className="flex items-center text-white text-lg">
              <i className="ri-map-pin-line w-6 h-6 flex items-center justify-center mr-3"></i>
              <span>Burj Al Arab, Dubai</span>
            </div>
          </div>
          
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
              <i className="ri-time-line text-yellow-500 text-2xl mr-3"></i>
              <span className="font-semibold">Ganztägiges Seminar</span>
            </div>
            <div className="flex items-center bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
              <i className="ri-map-pin-line text-yellow-500 text-2xl mr-3"></i>
              <span className="font-semibold">Burj Al Arab, Dubai</span>
            </div>
            <div className="flex items-center bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
              <i className="ri-user-star-line text-yellow-500 text-2xl mr-3"></i>
              <span className="font-semibold">25+ Jahre Expertise</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
